

































































import Vue from "vue";
import ThemeTextField from "@/components/molecules/ThemeTextField.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import { callApi } from "@/lib/api";
import { showNotifyDialog } from "@/lib/dialog";

// import { Plugin } from "@/lib/modified-status";
export default Vue.extend({
  components: { ThemeTextField, ButtonDefault },
  props: {
    novelId: String,
  },
  data() {
    return {
      goal: null,
      targetSegment: null,
      theme: {},
    };
  },
  methods: {
    change() {
      this.setModified(true);
    },
    async submit() {
      const { novelId, theme } = this;

      if (!this.isValidWordLength) {
        await showNotifyDialog({
          title: "入力エラー",
          content: "執筆予定文字数は半角数字で入力してください。",
        });
        return;
      }

      const detail = Object.keys(theme).map((key) => {
        return {
          name: key,
          value: theme[key],
        };
      });

      const input = {
        input: {
          novelId,
          detail,
        },
      };
      const UpdateTheme = `mutation UpdateTheme ($input: UpdateThemeInput!) {
        updateTheme(input: $input){
          novelId
          detail { name value }
        }
      }`;
      await callApi(UpdateTheme, input);

      this.$notify({
        title: "保存しました",
        type: "success",
      });

      this.setModified(false);
    },
  },
  computed: {
    isValidWordLength() {
      const { theme } = this;
      if (Object.prototype.hasOwnProperty.call(theme, "word-length") && isNaN(theme["word-length"])) {
        return false;
      }
      return true;
    },
  },
  async created() {
    const { novelId } = this;
    const Theme = `query Theme ($novelId: ID!) {
      theme(novelId: $novelId){
        novelId
        detail { name value }
      }
    }`;
    const { theme } = await callApi(Theme, { novelId });
    if (theme.detail) {
      const detail = {};
      theme.detail.forEach((item) => {
        detail[item.name] = item.value;
      });
      this.theme = detail;
    }
  },
});
